<template> 
    <div class="deposit-amount-wrapper">
        <div class="deposit-desktop withdraw-desktop d-flex">
            <div class="deposit-desktop__leftpage">

                <div class="withdraw-desktop__leftpage">
                    <div class="deposit-head">
                        <h3>{{$t('withdraw-funds','Withdraw funds')}}</h3>
                    </div>
                    <div class="page-help" data-bs-toggle="modal" data-bs-target="#withdrawal-help-modal">
                        <span class="page-help__text">Help</span>
                        <img class="page-help__img" src="@/assets/images/questionImg.webp" alt="questionImg" title="questionImg">
                    </div>

                </div>
                <div class="page-subtitle notes instruction-bg">
                    <p>{{$t('withdrawal-rule-1','1. This form is for withdrawing the amount from the main wallet only.')}}</p>
                    <p>{{$t('withdrawal-rule-2','2. The bonus wallet amount cannot be withdrawn by this form.')}}</p>
                    <p>{{$t('withdrawal-rule-3','3. Do not put Withdraw request without betting with deposit amount. Such activity may be identified as Suspicious')}}</p>
                    <p>{{$t('withdrawal-rule-4','4. If multiple users are using same withdraw account then all the linked users will be blocked.')}}</p>
                    <p>{{$t('withdrawal-rule-5','5. Maximum Withdraw time is 45 minutes then only complain on WhatsApp number.')}}</p>
                    <p>{{$t('withdrawal-account-should-be-same-to-deposit-account','6. Withdrawal account should be same to deposit account.')}}</p>
                </div>
                <TutorialVideo type = "3"/>
            </div>
            <div class="deposit-desktop__rightpage display-none">
                <div class="withdraw-rit-box deposit-amount-container">
                    <ul class="nav nav-tabs gap-2" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active px-2"  id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                            type="button" role="tab" aria-controls="pills-home" aria-selected="true" @click="tabSetting('New Account')">{{$t('use-new-acc','Use New Account')}}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link px-2"  id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
                            type="button" role="tab" aria-controls="pills-contact" aria-selected="false" @click="tabSetting('Previous Account')">{{$t('use-prev-acc','Use Previous Account')}}</button>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                            <createAccount :records="records" :bankDetails = "bankDetails"
                                @createAccount ="addAccount" 
                            />
                        </div>
                        <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                            <div class="amount-sec" v-if="userAccounts && userAccounts.length > 0">
                                <div class="match-odds-list-sec">
                                    <PreviousAccount :userAccounts ="userAccounts" :walletConfig = "walletConfig" :records="records" @getPreviousBankDetails ="getPreviousBankDetails"/>
                                </div>
                            </div>
                            <div class="deposit top-cards_wrapper p-0 m-0" v-else-if="userAccounts">
                                <div class="page-subtitle notes ps-0">
                                    <p>{{$t('no-new-account','No Account Available. Continue with new account')}}!!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="deposit-and-withdrawal-sec mobile-amount-wrapper">
        <div class="container">
            <div class="withdraw-desktop__leftpage add-scc-header-title">
                <h2 class="page-title pt-1">{{$t('withdraw-funds','Withdraw funds')}}</h2>
                <div class="d-flex pt-2">
                    <div class="withdraw-rit-box withdraw-ui me-2">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation" v-if="tabStatus == 'Previous Account'">
                                <button class="nav-link px-1" id="home-tab" data-bs-toggle="tab"
                                    data-bs-target="#mobile-use-new-account-tab" @click="tabSetting('New Account')">{{$t('create-new-account','Create New Account')}}</button>
                            </li>
                            <li class="nav-item" role="presentation" v-if="tabStatus == 'New Account'">
                                <button class="nav-link px-1" id="profile-tab" data-bs-toggle="tab"
                                    data-bs-target="#mobile-use-previous-account-tab" @click="tabSetting('Previous Account')">{{$t('use-prev-acc','Use Previous Accounts')}}</button>
                            </li>
                        </ul>
                    </div>
                    <div class="page-help" data-bs-toggle="modal" data-bs-target="#withdrawal-help-modal">
                        <span class="page-help__text">Help</span>
                        <img class="page-help__img" src="@/assets/images/questionImg.webp" alt="questionImg" title="questionImg">
                    </div>
                </div>
            </div>
            <div class="withdraw-desktop__rightpage">
                <!-- <div class="page-subtitle subtitle-hidden">Please fill in all required fields</div> -->
                <div class="withdraw-rit-box mt-0">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade" :class="{'show active' : tabStatus == 'New Account'}" id="mobile-use-new-account-tab" role="tabpanel"
                            aria-labelledby="home-tab">
                            <createAccount :is2faEnabled="is2faEnabled" :records="records" :bankDetails = "bankDetails"
                                :key="`create-${tabStatus}`"
                                @createAccount ="validateAccount" 
                            />
                        </div>
                        <div class="tab-pane fade" :class="{'show active' : tabStatus == 'Previous Account'}" id="mobile-use-previous-account-tab" role="tabpanel"
                            aria-labelledby="profile-tab">
                            <div class="amount-sec">
                                <div class="match-odds-list-sec" v-if="userAccounts && userAccounts.length">
                                    <PreviousAccount :userAccounts ="userAccounts" :records="records" :walletConfig = "walletConfig" @getPreviousBankDetails ="getPreviousBankDetails"/>
                                </div>
                                <div class="deposit top-cards_wrapper p-0 m-0" v-else>
                                    <div class="page-subtitle notes ps-2">
                                        <p>{{$t('no-new-account','No Account Available. Continue with new account')}}!!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TutorialVideo type = "3"/>
                </div>
            </div>
        </div>
        <div class="container" v-if="!is2faEnabled">
        <div class="forget-pass-link-sec">
            <a v-if="tabStatus == 'Previous Account'" class="pointer float-end forget-password-title" @click="openWithdrawPasswordModal">
                {{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?
            </a>
        </div>
        </div>
        <template v-if="!isAllEmpty && availableLanguages.length">
            <div class="guidePoint-details" >
                <ul class="nav nav-pills mb-2" id="pills-tab" role="tablist">
                <template v-for="lang in availableLanguages" :key="lang">
                    <li class="nav-item" role="presentation">
                    <button
                        class="nav-link"
                        :class="{ active: lang === currentLanguage }"
                        :id="`pills-${lang}-tab`"
                        data-bs-toggle="pill"
                        :data-bs-target="`#pills-${lang}`"
                        type="button"
                        role="tab"
                        :aria-controls="`pills-${lang}`"
                        :aria-selected="lang === currentLanguage"
                        @click="selectedLanguage = lang"
                    >
                        {{ lang }}
                    </button>
                    </li>
                </template>
                </ul>

                <div class="tab-content" id="pills-tabContent">
                    <template v-for="lang in availableLanguages" :key="lang">
                        <div
                        class="tab-pane fade show active"
                        v-show="lang === currentLanguage"
                        :id="`pills-${lang}`"
                        role="tabpanel"
                        :aria-labelledby="`pills-${lang}-tab`"
                        >
                        <div v-for="point in walletConfig.rules.withdrawal[lang]" :key="point.description">
                            <div class="guide-list" v-html="point?.description"></div>
                        </div>

                        <div class="text-center" v-if="walletConfig.rules.withdrawal[lang].length === 0">
                            {{ $t('no-data-found','No Data found!')}}
                        </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <section class="sub-header-wrapper" v-else>
            <div class="sub-header-tab pt-1 sub-header-tab-new">
                <div class="container =">
                    <ul class="nav nav-pills" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" :id="`pills-general-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-general`"
                                type="button" role="tab" :aria-controls="`pills-general`" aria-selected="true" >
                                {{$t('general-rules','General rules')}}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="sub-header-tab-con wallet-general-rule-container">
                <div class="container">
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active general-rule-warpper" :id="`pills-general`" role="tabpanel" :aria-labelledby="`pills-general-tab`">
                            <div class="language-list">
                                <p> {{ $t('this-form-is-for-withdrawing-the-amount', 'This form is for withdrawing the amount from the main wallet only') }}.</p>
                            </div>  
                            <div class="language-list">
                                <p> {{ $t('the-bonus-wallet-amount-cannot-be-withdrawn', 'The bonus wallet amount cannot be withdrawn by this form') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('do-not-put-withdraw-request-without-betting-with', 'Do not put Withdraw request without betting with deposit amount. Such activity may be identified as Suspicious') }}.</p>
                            </div>
                            <div class="language-list">
                                <p> {{ $t('If-multiple-users-are-using-same-withdraw', 'If multiple users are using same withdraw account then all the linked users will be blocked') }}.</p>
                            </div>
                            <div class="language-list">
                                <p>{{ $t('maximum-withdraw-time-is-45-minutes-then-only-complain', 'Maximum Withdraw time is 45 minutes then only complain on WhatsApp number') }}.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </div>
    <HelpModal/>
    <WithdrawPasswordModal  ref="withdrawSetReset" @selectTab="tabSetting" 
        :triggerAddAccountMethod="triggerAddAccountMethod"
    />
    <div class="modal fade modal-footer-sticky worli-Bets-Modal" id="askWithdrawPassModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{$t('withDraw-password','Withdraw password')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="account-delete-msg">
                        <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                    </div>
                    <div class="header-but info-footer edit-stake-btn">
                        <button @click="addAccount(true)" data-bs-dismiss="modal" type="button" class="thm-but thm-bor-but cancel-btn">{{ $t('cancel','Cancel') }}</button>
                        <button @click="openWithdrawPasswordModal()" type="button" class="thm-but">
                            {{ $t('continue', 'Continue') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <WalletInstructionVideos/>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { getUserAccounts, addAccount, openWithdrawPasswordModal,check2FaStatus } from '@template/utils'
import HelpModal from '../components/HelpModal.vue';
import CreateAccount from '../components/CreateAccount.vue';
import PreviousAccount from '../components/PreviousAccount.vue';
import WithdrawPasswordModal from '../components/WithdrawPasswordModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
export default {
    name: "WalletWithdraw",
    inject: ['walletConfig'],
    setup() {
		return { v$: useVuelidate() }
	},
    components: {
        HelpModal,
        CreateAccount,
        PreviousAccount,
        WithdrawPasswordModal,
        TutorialVideo,
        WalletInstructionVideos
    },
    data() {
        return {
            bankDetails:[],
            userAccounts:null,
            tabStatus: "New Account",
            accountData:null,
            records: {
                method_id: null,
                amount: null,
                bankId: null,
                account_holder_name: null,
                account_no: null,
                ifsc_code: null,
                withdrawal_password: null,
                termCondition: false,
                otp:null
            },
            activeLanguage: null,
            selectedLanguage: null,
            is2faEnabled:false
        }
    },
    computed : {
        isAllEmpty() {
            const withdrawal = this.walletConfig?.rules?.withdrawal;
            return Object.values(withdrawal).every(arr => arr.length === 0);
        },
        availableLanguages() {
            const withdrawal = this.walletConfig?.rules?.withdrawal || {};
            return Object.keys(withdrawal).filter(lang => withdrawal[lang]?.length > 0);
        },
        currentLanguage() {
            return this.availableLanguages.includes(this.selectedLanguage)
            ? this.selectedLanguage
            : this.availableLanguages[0] || null;
        },
    },
    created(){
       this.check2FaStatus()
    },
    mounted() {
        const messages = this.walletConfig?.rules?.withdrawal
        if (messages) {
            this.activeLanguage = Object.keys(messages)?.[0];
        }       
        this.bankDetails = this.walletConfig?.bank_list;
        this.tabSetting('Previous Account');
    },
    methods: {
        check2FaStatus(){
           const response = check2FaStatus();
            if(response?.is2faEnabled){
                this.is2faEnabled = true
           }
        },
       async getPreviousBankDetails(){
            try{
                let response = await getUserAccounts(this.walletConfig?.payment_method)
                this.userAccounts = response.userAccounts
            }
            catch(error){
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.[0]);
                }
            }
        },
        validateAccount(){
            this.records.method_id = this.records?.bankId?.id
            if (!this.records.termCondition || this.records.termCondition == null) {
                this.$errorToast('Please Accept Terms And Condition');
                return
            } 
            this.v$.$touch();
            // if (this.v$.$error) {				
            //     this.$errorToast('Please fill the required fields');
            //     return;
            // }
            this.addAccount()
        },
        async addAccount(){
            try{
                let response = await addAccount({method_type:'bank'}, 'bank', this.records, null,this.is2faEnabled)
                if(response){
                    this.v$.$reset();  
                    this.tabSetting('Previous Account') 
                }
            }catch(error){
                console.log(error)
            }
        },
        tabSetting(tabStatus) {
            this.tabStatus = tabStatus;
            this.records ={
                amount: null,
                bankId: null,
                account_holder_name: null,
                account_no: null,
                ifsc_code: null,
                withdrawal_password: null,
                termCondition: false
            }
            this.v$.$reset()
            if (tabStatus == "Previous Account") {
                this.getPreviousBankDetails();
            }
        },
        async openWithdrawPasswordModal(){
            try{
                let response = await openWithdrawPasswordModal()
                if(!response?.error){
                    this.$helper.openModal('#newUserWithDrawPasswordModel');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                if(error) {
                    this.$errorToast(error);
                }
            }
        },
        triggerAddAccountMethod(){
            this.addAccount();
        },
    }
}
</script>

<style>
.withdraw-ui .nav-tabs .nav-link {
    font-size: 12px;
    height: 25px;
}
</style>